<template>
	<div style="text-align: center;">
		
		<div style="border-bottom: 1px solid #f5f5f5;" v-if="show_status == 0">
			<br /><br /><br /><br />

			<span style="font-size: 0.8rem;">-</span>
			<br><br>
			<span style="font-size: 1.8rem;">支付成功</span>
			<br><br>

			<br/><span>订单编号: {{order_no}} </span>
			<br/><span>-</span>
			<br/><span>-</span>
		</div>


		<div v-if="show_status == 1">
			<p>加速审核，请上传付款截图</p>

			<div class="photo-box">
				<img :src='payinfo.image_link' style="border: 0;" />
				<div class="overlay"  @click="fileImage">上传付款截图</div>
				<!-- 照片上传input 隐藏样式 -->
				<input ref="fileImage" style="display: none;" class="upload" @change="addImage" type="file" />
			</div>
			<div class="payinfo"><input type="text" v-model="payinfo.pay_name" placeholder="姓名" /></div>
			<div class="payinfo"><input type="text" v-model="payinfo.pay_phone" placeholder="手机号（选)"  /></div>

			<span @click="addInfo" style="border: 0px none; padding:0.5rem 0; border-radius: 0.5rem; margin: 2rem auto;width: 10rem;display:block; color: #FFFFFF; background: rgba(255,96,96,1);">提交客服确认</span>
		</div>





		<!-- 组件使用 -->
		<!-- <foot /> -->
		<syalert ref="syalert_id" />

	</div>
</template>
<style>

.payinfo input
{
	margin: 0 auto;
	width: 12rem;
	height: 1.5rem;
	font-size: .7rem;
	text-indent: .3rem;
	border-bottom: 1px solid grey;
}
	
	
.photo-box {
      position: relative;
      width: 200px;
      height: 200px;
      display: inline-block;
    }

    .photo-box img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    /* 笼罩层 */
    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3); /* 黑色 50% 透明 */
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      text-align: center;
      padding: 8px;
      box-sizing: border-box;
    }


	
</style>
<script>
	// 组件引入
	import sy from "@/sy";
	import syalert from '@/components/syalert.vue';
	// import foot from '@/components/foot.vue';

	export default {
		name: 'paynotify',
		components: {
			// foot,
			syalert,
		},
		data() {
			return {
				show_status: 0,
				
				order_id: '',
				order_no: '',

				imgData: {
					accept: 'image/jpeg, image/jpg' //, image/png
				},
				payinfo: {
					image_id: '', // 付款截图
					image_link : '', // 付款截图
					pay_name: '', // 真是姓名
					pay_phone: '', // 真是号码
				},
			}
		},
		methods: {
			pageTo: function(page) {
				if (page !== undefined) {
					this.$router.push(page);
				} else {
					this.$router.go(-1);
				}
			},



			fileImage: function() {
				this.$refs.fileImage.dispatchEvent(new MouseEvent('click'))
			},

			/**
			 *  
			 * 
			*/
			addImage: function(event) {
				let ishead = this.$router.currentRoute.query.ishead;
				if (ishead === undefined) {
					ishead = 0;
				}

				//let reader =new FileReader();
				let img1 = event.target.files[0];
				let type = img1.type; //文件的类型，判断是否是图片
				let size = img1.size; //文件的大小，判断图片的大小
				if (this.imgData.accept.indexOf(type) == -1) {
					alert('请选择我们支持的图片格式！:jpeg或jpg');
					return false;
				}
				if (size > 1024 * 1024 * 6) {
					alert('请选择6M以内的图片！'); // 3145728 = 1024 * 1024 * 3
					return false;
				}
				this.$refs.syalert_id.syalert('正在上传,请稍等');

				let $_this = this;
				sy.filechunk.progress = function(res) {
					// $_this.userInfo.head = res.data.link;
					if (res.state === '0' || res.state === '1') {

						$_this.$refs.syalert_id.syalert(res.msg);
						
						$_this.payinfo.image_id = res.data.image_id;
						$_this.payinfo.image_link = res.data.image_link;
					}
					// $_this.getHead();
					// $_this.getImage();
				}
				sy.filechunk.init({
					"file": event.target.files[0],
					"url": "https://www.humall2026.cn/app/Image/Add",
					"data": {
						order_id: $_this.order_id,
					}
				});
			},
			
			
			
			
			
			/**
			 * 上传: 付款截图 + 真实姓名 + 手机号
			 * 回调: 检查对应的 回调逻辑  后期看一把回调内容迁移到 业务订单上去 这样可以充分 和原系统的 支付模块解耦
			 *
			 *
			 * 地址: https://m.humall2026.cn/order/cashnotify?order_no=xxx&pay_id=
			 * 地址: https://www.humall2026.cn/api/v0/Paygate/AddInfo?order_id=657&image_id=&pay_name=
			 *
			 *
			 */
			addInfo: function() { 
				console.log(this.order_id);
				if (this.order_id === undefined)
				{
					console.log('无 this.order_id');
					return false;
				}
				// 实例重命名
				// let $_this = this;
				sy.http.get({
					url: this.$root.API + 'Paygate/AddInfo',
					data: {
						'order_id': this.order_id,
						'image_id': this.payinfo.image_id,
						'pay_name': this.payinfo.pay_name,
					},
					success: function(res) {
						if (res.state === '0') {
							console.log(res.msg);
							return false;
							//return $_this.$refs.syalert_id.syalert(res.msg);
						}

						location.href = res.data.return_url;
						//console.log(res.data.return_url);
					}
				});

			},
			// 检查订单类型
			check: function() { 
				console.log(this.order_id);
				if (this.order_id === undefined)
				{
					console.log('无 this.order_id');
					return false;
				}
				// 实例重命名
				let $_this = this;
				sy.http.get({
					url: this.$root.API + 'Paygate/Cashnotify',
					data: {
						'order_id': this.order_id,
					},
					success: function(res) {
						// if (res.state === '0') {
						// 	console.log(res.msg);
						// 	return false;
						// }
						
						$_this.show_status = res.state;
					}
				});

			},
		},
		created() {
			this.pay_id = this.$router.currentRoute.query.pay_id;
			this.order_id = this.$router.currentRoute.query.order_id;
			this.order_no = this.$router.currentRoute.query.order_no;
			this.check();
		},
	}
</script>